import React, { FunctionComponent, useMemo } from 'react'
import { Trans } from '@lingui/macro'

import Spinner, {
  SpinnerSizeEnum
} from '../../../../components/common/spinner/Spinner'
import { IUploadProgress } from '../../types/ProcessUsersImportUploadTypes'

interface IUploadProgressProps {
  progress: IUploadProgress
}

export const UploadProgress: FunctionComponent<IUploadProgressProps> = ({
  progress
}) => {
  const progressPercentage = useMemo(
    () => (progress ? Math.round((progress.loaded / progress.total) * 100) : 0),
    [progress]
  )

  return (
    <div className="BulkUsersImportPage__step uploading-file-step">
      <h4 className="loading-caption">
        <Trans>Uploading...</Trans>
      </h4>
      <Spinner size={SpinnerSizeEnum.large} progress={progressPercentage} />
    </div>
  )
}
